<template>
  <div v-if="isShown">
    <div class="invite-members-modal">
      <span class="icon-close" v-on:click="resetModal" />

      <div class="invite-members-modal-content">
        <div @click="openUpdateListTitleModal()">
          <h2>{{ pageTitle }}</h2>
          <h4 class="page-description">{{ pageDescription }}</h4>
        </div>

        <div v-if="isOwner">
          <email-input :act="inviteMember"></email-input>
          <div class="invite-with-link">
            <div
              class="invite-with-link-button"
              @click="copyToClipboard(shareLinkUrl)"
            >
              <span class="icon-link primary-color"></span>
              <span class="share-text bold primary-color"
                >Invite with link</span
              >
            </div>
            <div class="toggle">
              <toggle-switch
                :checkbox.sync="checkbox"
                :act="toggleCheckbox"
              ></toggle-switch>
            </div>
          </div>
        </div>

        <member-list
          :act="deleteMemberFromList"
          :isOwner="isOwner"
          :members="membersNames"
        ></member-list>

        <invitations-list
          v-if="isOwner"
          :act="deleteInvitedFromList"
          :emails="invited"
        ></invitations-list>
      </div>
    </div>
    <div class="overlay" @click="resetModal"></div>
  </div>
</template>

<script>
import UuidEncoder from "uuid-encoder";

import bus from "../bus";
import api from "../api";

import EmailInput from "@/components/members/EmailInput";
import InvitationsList from "@/components/members/InvitationsList";
import MemberList from "@/components/members/MemberList";
import ToggleSwitch from "../components/shared/ToggleSwitch";

import getInvitedByList from "../gql/invited/getInvitedByList.gql";
import deleteInvited from "../gql/invited/deleteInvited.gql";
import createInvited from "../gql/invited/createInvited.gql";
import updateSharingLinkList from "../gql/lists/updateSharingLinkList.gql";

export default {
  components: {
    EmailInput,
    InvitationsList,
    MemberList,
    ToggleSwitch,
  },
  data() {
    return {
      isShown: false,
      checkbox: this.list.link_sharing,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    listIdEncoded() {
      const encoder = new UuidEncoder("base36");
      return encoder.encode(this.listId);
    },
    listIdDecoded() {
      const encoder = new UuidEncoder("base36");
      return encoder.decode(this.listIdEncoded);
    },
    shareLinkUrl() {
      return "otti.io/welcometolist/" + this.listIdEncoded;
    },
  },
  apollo: {
    $subscribe: {
      invited: {
        query: getInvitedByList,
        variables() {
          return {
            list_id: this.listId,
          };
        },
        update: (data) => data.invited,
        result(data) {
          this.invited = data.data.invited;
        },
      },
    },
  },
  methods: {
    inviteMember: function (emailRaw) {
      let alreadyInvited = false;

      const email = emailRaw.toLowerCase();

      for (let i = 0; i < this.invited.length; i++) {
        if (this.invited[i].email == email) {
          alreadyInvited = true;
          alert("This email has already been invited");
        }
      }

      for (let i = 0; i < this.membersNames.length; i++) {
        if (this.membersNames[i].email == email) {
          alreadyInvited = true;
          alert("This email belongs to an already existing member of the list");
        }
      }

      if (!alreadyInvited && email != "") {
        const list_id = this.listId;

        this.$apollo
          .mutate({
            mutation: createInvited,
            variables: {
              email,
              list_id,
            },
          })
          .then(() => {
            api.createEventTracking(
              "member-invited-list-page",
              "member-invited",
              this.user.id,
              true
            );

            let nameEmail = this.user.name;

            if (this.user.surname && this.user.surname != "") {
              nameEmail = this.user.name + " " + this.user.surname;
            }

            api.sendInvitationEmail(
              email,
              this.list.title,
              nameEmail,
              "https://www.otti.io/lists/" + this.listId
            );
          });
      }
    },
    deleteInvitedFromList: function (email) {
      this.$apollo
        .mutate({
          mutation: deleteInvited,
          variables: {
            email,
          },
        })
        .then(() => {
          api.createEventTracking(
            "invitation-deleted",
            "invitation-deleted",
            this.$store.state.user.id,
            true
          );
        });

      let newEmailList = JSON.parse(JSON.stringify(this.invited));

      for (let i = 0; i < newEmailList.length; i++) {
        if (newEmailList[i].email == email) {
          newEmailList.splice(i, 1);
          break;
        }
      }
      this.invited = newEmailList;
    },

    deleteMemberFromList: function (memberId) {
      if (memberId == this.user.id) {
        alert("You can't remove yourself if you are the owner of the list");
        return;
      }
      api.removeMemberFromList(this.listId, memberId, this.user.id);
    },
    resetModal: function () {
      this.isShown = false;
    },
    addMembersModalEvent: function () {
      bus.$on("add-members-mode", () => {
        this.isShown = true;
      });
    },
    copyToClipboard: async function (s) {
      if (!this.checkbox) {
        this.toggleCheckbox();
      }

      await navigator.clipboard.writeText(s);
      alert("Link copied in the clipboard!");
    },
    toggleCheckbox() {
      const id = this.listId;
      const link_sharing = !this.checkbox;

      this.$apollo
        .mutate({
          mutation: updateSharingLinkList,
          variables: {
            id,
            link_sharing,
          },
        })
        .then((res) => {
          this.checkbox = res.data.update_lists_by_pk.link_sharing;
        })
        .catch((error) => {
          this.$rollbar.error(error);
          alert("We are sorry, there was an error during the sharing of the list. Please try again later.");
        });
    },
    openUpdateListTitleModal() {
      if (this.isOwner) {
        this.isShown = false;
        bus.$emit("open-modal", "UpdateListTitleModal", "list", this.list);
      }
    },
  },
  beforeMount: function () {
    this.addMembersModalEvent();
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
    listId: {
      type: String,
      required: true,
    },
    membersNames: {
      type: Array,
      required: true,
    },
    isOwner: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    pageDescription: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.invite-members-modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: theme.$white-background;
  padding: 0px theme.$page-padding-X;
  z-index: 20;
  overflow: scroll;
}

.invite-members-modal-content {
  margin-top: 80px;
  margin-bottom: 20px;
  overflow: visible;
}

.invite {
  margin-top: 30px;
}

.member-list,
.invitations-list {
  margin-top: 24px;
}

.page-description {
  font-size: 14px;
  font-weight: 400;
  white-space: pre-wrap;
}

span.icon-close {
  cursor: pointer;
  font-size: 24px;
  position: absolute;
  top: 30px;
  right: 30px;
}

.invite-with-link {
  margin-top: 8px;
}

.invite-with-link-button {
  border-radius: theme.$button-border-radius;
  padding: 6px 8px;
  display: inline-block;
}

.invite-with-link-button:hover {
  background-color: theme.$secondary-color;
}

span.icon-link {
  cursor: pointer;
  font-size: 18px;
  vertical-align: sub;
}

span.share-text {
  margin-left: 6px;
}

.toggle {
  transform: scale(0.8, 0.8);
  display: inline-block;
  vertical-align: middle;
}

@media (min-width: 768px) {
  .invite-members-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: fit-content;
    max-height: 800px;
    z-index: 20;
    background-color: theme.$white-background;
    padding: 0px theme.$page-padding-X;
    overflow: scroll;
  }

  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: theme.$dark-grey-background;
    opacity: 0.6;
    padding: 0px theme.$page-padding-X;
    z-index: 15;
  }
}
</style>